import { Grid, Button, Box, IconButton } from '@mui/material';
import { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import LanguageIcon from './img/languageIcon.svg';
import ContactIcon from './img/contactIcon.svg';
import { topHeaderStyles as styledClasses } from './TopHeaderStyles';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import OrientalImage from '../../images/oriental-bank.svg';
import OrientalImageText from '../../images/logo-text.svg';
import OrientalImageTextDark from '../../images/FDIC-logo-dark.svg';
import { dgiMapping } from '../../services/dgiMapping';
import {
  HOME_VI,
  ESP,
  ENG,
  PERSONAL_INFO,
  FINANCE_INFO,
  LANGUAGE_ICON,
  CHANGE_LANGUAGE,
  USER_LOGO,
  HELLO,
  ORIENTAL_LOGO,
  DGIADDITIONAL_INFO,
  BUSINESS_COMP,
  BUSINESS_ACCOUNT_INFO,
  BUSINESS_SURI,
  BUSINESS_ADDITIONAL_INFO,
  BUSINESS_COMPLIANCE_INFO,
  BUSINESS_INFO,
  FUNDING_INFO,
  PRODUCT_INFO,
  COMPLIANCE_INFO,
  ADDRESS_INFO,
  CONTACT_INFO,
  ES,
  LIBRE_AHORRA_BUNDLE,
} from '../../constants';
import { businessMapping } from '../../services/businessMapping';
import { productTypeMapping } from '../../services/productTypeMapping';
import { commonTernary, isBundle } from '../commonCode';
import { DarkTheme, LightTheme } from '../../theme/globalTheme';
import { LanguageIcon as LangIcon, ThemeMoonIcon, FDICLogo } from '../../images/svg/CustomizedSVG';

export default function TopHeader(props) {
  const { setLanguage, firstName } = props;
  const [languageString, setLanguageString] = useState(ESP);
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { productName, isLightTheme } = leadGenerationContext;

  const location = useLocation();
  useEffect(() => {
    const storedProductName = localStorage.getItem('productName');
    if (!leadGenerationContext.productName && storedProductName) {
      leadGenerationContext.setProductName(storedProductName);
    }
  }, []);
  useEffect(() => {
    if (leadGenerationContext.productName) {
      localStorage.setItem('productName', leadGenerationContext.productName);
    }
  }, [leadGenerationContext.productName]);
  useEffect(() => {
    if (location.pathname === '/' || location.pathname === '/home') {
      leadGenerationContext.setProductName('');
      localStorage.removeItem('productName');
    }
  }, [location.pathname]);

  useEffect(() => {
    if (firstName?.length === 0) {
      leadGenerationContext.setUserName('Guest');
    }
    if (firstName?.length > 0) {
      leadGenerationContext.setUserName(`${firstName}`);
    }
  }, [firstName]);

  useEffect(() => {
    if (leadGenerationContext.language === ES || leadGenerationContext.language === ESP) {
      setLanguageString(ENG);
      setLanguage(ESP);
    } else {
      setLanguageString(ESP);
      setLanguage(ENG);
    }
    console.log({ languageString, lang: leadGenerationContext.language });
  }, [leadGenerationContext.language]);
  const setHeaderLanguage = () => {
    leadGenerationContext.setSuriLang(true);
    if (languageString === ESP) {
      setLanguageString(ENG);
      setLanguage(ESP);
    } else {
      setLanguageString(ESP);
      setLanguage(ENG);
    }
  };
  const setAddressInfoPage = () => {
    if (dgiMapping(leadGenerationContext.productName)) {
      leadGenerationContext.setIsScreenThreeDirty(true);
      leadGenerationContext.setIsTrustInfoDirty(true);
      leadGenerationContext.setIsFinanceInfoDirty(true);
      leadGenerationContext.setIsFundingScreenDirty(true);
    } else {
      leadGenerationContext.setIsScreenThreeDirty(true);
      leadGenerationContext.setIsScreenFourDirty(true);
      leadGenerationContext.setIsScreenFiveDirty(true);
      leadGenerationContext.setIsFundingScreenDirty(true);
    }
  };
  const currentPageCondition = () => {
    if (leadGenerationContext.currentPage === BUSINESS_COMPLIANCE_INFO) {
      leadGenerationContext.setIsBusinessComplianceDirty(true);
      leadGenerationContext.setIsBusinessSuriDirty(true);
      leadGenerationContext.setIsBusinessAdditionalInfoDirty(true);
      leadGenerationContext.setIsBusinessAccountInfoDirty(true);
      leadGenerationContext.setIsBusinessCompDirty(true);
      leadGenerationContext.setIsDocChecklistDirty(true);
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    if (leadGenerationContext.currentPage === BUSINESS_ADDITIONAL_INFO) {
      leadGenerationContext.setIsBusinessAdditionalInfoDirty(true);
      leadGenerationContext.setIsBusinessAccountInfoDirty(true);
      leadGenerationContext.setIsBusinessCompDirty(true);
      leadGenerationContext.setIsDocChecklistDirty(true);
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    if (leadGenerationContext.currentPage === BUSINESS_SURI) {
      leadGenerationContext.setIsBusinessSuriDirty(true);
      leadGenerationContext.setIsBusinessAdditionalInfoDirty(true);
      leadGenerationContext.setIsBusinessAccountInfoDirty(true);
      leadGenerationContext.setIsBusinessCompDirty(true);
      leadGenerationContext.setIsDocChecklistDirty(true);
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    if (leadGenerationContext.currentPage === BUSINESS_ACCOUNT_INFO) {
      leadGenerationContext.setIsBusinessAccountInfoDirty(true);
      leadGenerationContext.setIsBusinessCompDirty(true);
      leadGenerationContext.setIsDocChecklistDirty(true);
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    if (leadGenerationContext.currentPage === BUSINESS_COMP) {
      leadGenerationContext.setIsBusinessCompDirty(true);
      leadGenerationContext.setIsDocChecklistDirty(true);
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    if (leadGenerationContext.currentPage === 'document-checklist') {
      leadGenerationContext.setIsDocChecklistDirty(true);
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    if (leadGenerationContext.currentPage === FINANCE_INFO) {
      leadGenerationContext.setIsFinanceInfoDirty(true);
      leadGenerationContext.setIsFundingScreenDirty(true);
    }
    if (leadGenerationContext.currentPage === DGIADDITIONAL_INFO) {
      leadGenerationContext.setIsTrustInfoDirty(true);
      leadGenerationContext.setIsFinanceInfoDirty(true);
      leadGenerationContext.setIsFundingScreenDirty(true);
    }
  };
  const sendLanguage = () => {
    setHeaderLanguage();
    if (leadGenerationContext.currentPage === CONTACT_INFO) {
      leadGenerationContext.setIsScreenOneDirty(true);
      leadGenerationContext.setIsScreenTwoDirty(true);
      leadGenerationContext.setIsScreenThreeDirty(true);
      leadGenerationContext.setIsScreenFourDirty(true);
      leadGenerationContext.setIsScreenFiveDirty(true);
      leadGenerationContext.setIsFundingScreenDirty(true);
    }
    if (leadGenerationContext.currentPage === PERSONAL_INFO) {
      leadGenerationContext.setIsScreenTwoDirty(true);
      leadGenerationContext.setIsScreenThreeDirty(true);
      leadGenerationContext.setIsScreenFourDirty(true);
      leadGenerationContext.setIsScreenFiveDirty(true);
      leadGenerationContext.setIsFundingScreenDirty(true);
    }
    if (leadGenerationContext.currentPage === ADDRESS_INFO) {
      setAddressInfoPage();
    }
    if (leadGenerationContext.currentPage === COMPLIANCE_INFO) {
      leadGenerationContext.setIsScreenFourDirty(true);
      leadGenerationContext.setIsScreenFiveDirty(true);
      leadGenerationContext.setIsFundingScreenDirty(true);
    }
    if (leadGenerationContext.currentPage === PRODUCT_INFO) {
      if (
        businessMapping(leadGenerationContext.productName) &&
        (productTypeMapping(leadGenerationContext.productType) === 'Checking Account' ||
          productTypeMapping(leadGenerationContext.productType) === 'Savings Account')
      ) {
        leadGenerationContext.setIsCommercialProductUIDirty(true);
      }
      leadGenerationContext.setIsFundingScreenDirty(true);
      leadGenerationContext.setIsScreenFiveDirty(true);
    }
    if (leadGenerationContext.currentPage === FUNDING_INFO) {
      leadGenerationContext.setIsFundingScreenDirty(true);
    }
    if (leadGenerationContext.currentPage === BUSINESS_INFO) {
      leadGenerationContext.setIsBusinessContactInfoDirty(true);
      leadGenerationContext.setIsBusinessComplianceDirty(true);
      leadGenerationContext.setIsBusinessSuriDirty(true);
      leadGenerationContext.setIsBusinessAdditionalInfoDirty(true);
      leadGenerationContext.setIsBusinessAccountInfoDirty(true);
      leadGenerationContext.setIsBusinessCompDirty(true);
      leadGenerationContext.setIsDocChecklistDirty(true);
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    currentPageCondition();
  };
  useEffect(() => {
    if (leadGenerationContext.isLightTheme) {
      leadGenerationContext.setTheme(LightTheme);
    } else {
      leadGenerationContext.setTheme(DarkTheme);
    }
  }, [leadGenerationContext.isLightTheme]);

  const handleTheme = () => {
    leadGenerationContext.setIsLightTheme(!leadGenerationContext.isLightTheme);
  };

  const bundleHeader = () => (
    <Grid
      container
      sx={{
        ...styledClasses.top_header,
        ...{ boxShadow: '0px 4px 12px 0px #44444414' },
        ...((isBundle(leadGenerationContext.productName) ||
          leadGenerationContext.flowTypeVerifyScreen === 'bundleLoginScreen') && {
          color: leadGenerationContext?.theme?.palette?.primary?.main,
          backgroundColor: leadGenerationContext?.theme?.palette?.headerBackground?.main,
          '@media (max-width:400px)': {
            width: '100%',
          },
        }),
      }}
    >
      <Box sx={styledClasses.leftHeaderSectionBundle}>
        <Box
          component="img"
          src={OrientalImage}
          alt="Oriental Logo"
          sx={styledClasses.orientalBundle}
        />
        <Box sx={styledClasses.fdicsideBundle}>
          {isLightTheme && !isBundle(productName) ? (
            <Box
              component="img"
              src={OrientalImageText}
              alt="FDIC Logo"
              sx={styledClasses.orientalfdicBundle}
            />
          ) : isLightTheme && isBundle(productName) ? (
            <FDICLogo />
          ) : !isLightTheme && !isBundle(productName) ? (
            <Box
              component="img"
              src={OrientalImageTextDark}
              alt="FDIC Logo"
              sx={styledClasses.orientalfdicBundle}
            />
          ) : (
            <FDICLogo color="#FFFFFF" subColor="#FFFFFF" />
          )}
        </Box>
      </Box>
      <Box sx={styledClasses.bundleMobileHeader}>
        {leadGenerationContext.currentPage !== 'etb-login' &&
          leadGenerationContext.currentPage !== 'otp-screen' &&
          leadGenerationContext.currentPage !== 'received-code' &&
          leadGenerationContext.currentPage !== '' && (
            <IconButton onClick={handleTheme}>
              <ThemeMoonIcon color={leadGenerationContext?.theme?.palette?.orientalPrimary?.main} />
            </IconButton>
          )}

        <Box sx={styledClasses.right_mobile_header_bundle}>
          <Button
            disableFocusRipple
            onClick={setHeaderLanguage}
            sx={{
              ...styledClasses.lang_change_button,
              ...(isBundle(leadGenerationContext.productName) && { fontWeight: 600 }),
            }}
            type="button"
            variant="subtitle1"
            aria-label={t(CHANGE_LANGUAGE, { defaultValue: CHANGE_LANGUAGE })}
          >
            <LangIcon
              heigth="25px"
              width="25px"
              color={leadGenerationContext?.theme?.palette?.orientalPrimary?.main}
            />
            {leadGenerationContext.location === HOME_VI && ENG}
            {languageString === ENG && leadGenerationContext.location !== HOME_VI && ENG}
            {languageString === ESP && leadGenerationContext.location !== HOME_VI && ESP}
          </Button>
        </Box>
      </Box>
    </Grid>
  );

  const defaultHeader = () => (
    <Grid container sx={styledClasses.top_header}>
      <a
        href="#main-content"
        aria-label="skip to main content"
        id="skipToMain"
        className="skiptocontent"
        tabIndex="0"
      >
        skip to main content
      </a>
      <Box>
        <Box sx={styledClasses.leftHeaderSection}>
          <Box
            component="img"
            src={OrientalImage}
            alt={ORIENTAL_LOGO}
            aria-label="Oriental Logo"
            sx={styledClasses.oriental}
          />

          <Box sx={styledClasses.right_mobile_header}>
            {leadGenerationContext.location !== HOME_VI ? (
              <Button
                disableFocusRipple
                data-testid="topHeader_btnid"
                onClick={sendLanguage}
                disabled={leadGenerationContext.location === HOME_VI}
                sx={styledClasses.lang_change_button}
                type="button"
                aria-label={t(CHANGE_LANGUAGE, { defaultValue: CHANGE_LANGUAGE })}
              >
                <Box
                  component="img"
                  src={LanguageIcon}
                  alt={LANGUAGE_ICON}
                  aria-label="Language Icon"
                  sx={styledClasses.language_icon}
                />
                {leadGenerationContext.location === HOME_VI && ENG}
                {console.log({
                  btnTxt:
                    languageString === ENG && leadGenerationContext.location !== HOME_VI && ENG,
                  btnTxtEsp:
                    languageString === ESP && leadGenerationContext.location !== HOME_VI && ESP,
                })}
                {languageString === ENG && leadGenerationContext.location !== HOME_VI && ENG}
                {languageString === ESP && leadGenerationContext.location !== HOME_VI && ESP}
              </Button>
            ) : (
              ''
            )}
          </Box>
        </Box>
        <div>
          <Box
            component="img"
            src={OrientalImageText}
            alt="FDIC Insured"
            aria-label="FDIC Insured"
            sx={styledClasses.orientalText}
          />
        </div>
      </Box>
      <Box
        sx={styledClasses.username_block}
        aria-label={`${t(HELLO, { defaultValue: HELLO })} ${t(leadGenerationContext.userName, {
          defaultValue: leadGenerationContext.userName,
        })}`}
      >
        {`${t(HELLO, { defaultValue: HELLO })} ${t(leadGenerationContext.userName, {
          defaultValue: leadGenerationContext.userName,
        })}`}
        <Box
          component="img"
          src={ContactIcon}
          alt={USER_LOGO}
          aria-label="User Logo"
          sx={styledClasses.profile_icon}
        />
      </Box>
    </Grid>
  );

  const topHeader = commonTernary(
    isBundle(leadGenerationContext.productName) ||
      leadGenerationContext.flowTypeVerifyScreen === 'bundleLoginScreen',
    bundleHeader(),
    defaultHeader()
  );

  return topHeader;
}

TopHeader.propTypes = {
  firstName: PropTypes.string,
  setLanguage: PropTypes.func,
};
